import React from "react";
import { BaseFullScreenTakeover } from "../../Components/BaseFullScreenTakeover";
import { PaymentPrefCreationForAccountsWorkflow } from "../../Workflows/PaymentPrefCreationForAccountsWorkflow";
import { PaymentPrefForAccountsContainerProps } from "./types";

export const PaymentPrefForAccountsContainer = ({
  accounts,
  onExit,
  onSuccess,
}: PaymentPrefForAccountsContainerProps) => {
  return (
    <BaseFullScreenTakeover title="Update payment method" onExit={onExit}>
      <PaymentPrefCreationForAccountsWorkflow
        accounts={accounts}
        onSuccess={onSuccess}
        onExit={onExit}
      />
    </BaseFullScreenTakeover>
  );
};

export type { PaymentPrefForAccountsContainerProps };
